import ModalForm from "./Form";
import {
	PRODUCT,
	DATATABLE_EXPORT,
	PRODUCT_CATEGORY,
	CLC_CALENDAR
} from "../../../../Config/ApiUrl";

export const Schema = {
	components: { ModalForm },

	data() {
		// const defaultSemester = [];
		return {
			tableReady: true,
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			tableId: "PRODUCT-table",
			rowData: {},
			formId: "PRODUCT-form",
			// defaultSemester: [],
			tableColumns: [
				// {
				// 	title: 'Semester',
				// 	type: "object",
				// 	key: "academic_calendar",
				// 	modifier: (v) => {
				// 		return v ? v.academic_calendar_name : "";
				// 	},
				// },
				{
					title: this.$t("product_category"),
					type: "object",
					key: "product_category",
					modifier: (v) => {
						return v ? v.name : "";
					},
				},
				{
					title: 'Product ID',
					type: "text",
					key: "resource_id",
				},
				{
					title: this.$t("name"),
					type: "text",
					key: "name",
				},
				{
					title: this.$t("description"),
					type: "text",
					key: "description",
				},
				// {
				// 	title: this.$t("center"),
				// 	type: "object",
				// 	key: "center_id",
				// 	modifier: (v) => {
				// 		return v ? v.name : "";
				// 	},
				// },
				{
					title: this.$t("price"),
					type: "custom-html",
					key: "price",
					modifier: (value) => {
						return this.formattedIDR(value) ? this.formattedIDR(value) : this.formattedIDR(0);
					},
				},
				{
					title: this.$t("is_active"),
					type: "custom-html",
					key: "is_active",
					isVisible: true,
					modifier: (value) => {
						let ClassName = "danger";

						if (value === 1) ClassName = `success`;
						else if (value === 0) ClassName = `warning`;

						return `<span class="badge badge-sm badge-pill badge-${ClassName}">${
							value ? "Active" : "Inactive"
						}</span>`;
					},
				},
			],
			ENDPOINT: PRODUCT + "?product_category_exclude=3,2",
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "Product",
				url: PRODUCT + "?product_category_exclude=3,2",
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					{
						title: this.$t("edit"),
						icon: "edit",
						type: "none",
						component: "app-add-modal",
						modalId: "PRODUCT-form",
						modifier: () => this.$can('view_list_product_button_modalupdateinfo')
					},
					{
						title: this.$t("delete"),
						icon: "trash",
						type: "none",
						component: "app-confirmation-modal",
						modalId: "demo-delete",
						modifier: () => this.$can('view_list_product_button_delete')
					},
				],
				filters: [
					{
						title: this.$t("is_active"),
						type: "checkbox",
						key: "is_active",
						option: [
							{ id: true, value: "Active" },
							{ id: false, value: "Inactive" },
						],
					},
					// {
					// 	title: "Semester",
					// 	type: "search-and-select-filter",
					// 	key: "semester",
					// 	defaultValue: defaultSemester,
					// 	value: defaultSemester,
					// 	settings: {
					// 		url: `/${CLC_CALENDAR}`, 
					// 		modifire: (v) => {
					// 			return { id: v.id, name: v.academic_calendar_name };
					// 		},
					// 		per_page: 10, 
					// 		queryName: "search", 
					// 		loader: "app-pre-loader", 
					// 		multiple: true,
					// 		params: {
					// 			is_active: true,
					// 		}, 
					// 	},
					// 	listValueField: "name",
					// },
					{
						title: "Product Category",
						type: "search-and-select-filter",
						key: "product_category",
						settings: {
							url: `/${PRODUCT_CATEGORY}`,
							modifire: (v) => {
								return { id: v.id, name: v.name };
							},
							per_page: 10, 
							queryName: "search", 
							loader: "app-pre-loader",
							multiple: true,
							params: {
								is_active: true,
							}, 
						},
						listValueField: "name",
					},
				],
				
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 10,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	// async created() {
	// 	try {
	// 		const res = await this.axiosGet(CLC_CALENDAR, { params: { is_active: true } });
	// 		if (res.data.data.length > 0) {
	// 			const firstSemester = res.data.data[0];
	// 			const formattedSemester = [{ id: firstSemester.id, name: firstSemester.academic_calendar_name }];
	// 			this.defaultSemester = formattedSemester;

	// 			const semesterFilter = this.options.filters.find(f => f.key === 'semester');
	// 			semesterFilter.value = formattedSemester;
	// 			semesterFilter.defaultValue = formattedSemester;
	// 		}
	// 	} catch (e) {
	// 		console.error(e);
	// 	} finally {
	// 		this.tableReady = true;
	// 		this.$nextTick(() => {
	// 			this.$hub.$emit('datatable-filter-set', {
	// 				tableId: this.tableId,
	// 				filters: { semester: this.defaultSemester }
	// 			});

	// 			this.$hub.$emit(`reload-${this.tableId}`);
	// 		});
	// 	}
	// },
	methods: {
		onDelete() {
			let url = PRODUCT + "/" + this.rowData.id;
			this.deleteLoader = true;
			this.axiosDelete(url)
				.then((response) => {
					this.deleteLoader = false;
					$("#demo-delete").modal("hide");
					this.onCancelDelete();
					this.$toastr.s(response.data.message);
					// this.searchAndSelectFilterOptions();
				})
				.catch(({ err }) => {})
				.finally(() => this.$hub.$emit(`reload-${this.tableId}`));
		},
		onCancelDelete() {
			this.deleteConfirmationModalActive = false;
			this.reSetData();
		},
		reSetData() {
			this.rowData = {};
			this.selectedUrl = "";
		},
		formattedIDR(value) {
			// Format the value as IDR
			return new Intl.NumberFormat("id-ID", {
				style: "currency",
				currency: "IDR",
				minimumFractionDigits: 0,
			}).format(value);
		},
	},
};
